// src/pages/Dashboard.jsx
import React from "react";
import { Link } from "react-router-dom";

const enrolledCourses = [
  {
    id: "cyber-security",
    title: "Cyber Security Internship",
    totalModules: 5,
  },
  {
    id: "python-programming",
    title: "Python Programming Internship",
    totalModules: 28,
  },
  {
    id: "ai-ml",
    title: "AI & ML Internship",
    totalModules: 5,
  },
  {
    id: "web-dev",
    title: "Web Development Internship",
    totalModules: 5,
  },
  {
    id: "blockchain",
    title: "Blockchain Internship",
    totalModules: 5,
  },
];


const getCompletedModules = (courseId, total) => {
  let count = 0;
  for (let i = 1; i <= total; i++) {
    if (localStorage.getItem(`module-${courseId}-${i}-done`) === "true") {
      count++;
    }
  }
  return count;
};

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 px-6 py-20 max-w-5xl mx-auto">
  <h2 className="text-4xl font-bold text-indigo-600 mb-8 text-center">🎓 My Dashboard</h2>

  {enrolledCourses.map((course) => {
    const completed = getCompletedModules(course.id, course.totalModules);
    const isCompleted = completed === course.totalModules;

    return (
      <div
        key={course.id}
        className="bg-white p-6 rounded-xl mb-6 shadow-md flex flex-col md:flex-row justify-between items-center gap-6 transition-shadow hover:shadow-xl"
      >
        <div className="flex-1 min-w-0">
          <h3 className="text-xl font-semibold mb-2 truncate">{course.title}</h3>
          <p className="text-sm text-gray-600">
            Progress: {completed}/{course.totalModules} modules
          </p>
          <div className="w-full bg-gray-300 rounded h-2 mt-2 overflow-hidden">
            <div
              className="bg-indigo-600 h-2 rounded transition-all duration-300"
              style={{ width: `${(completed / course.totalModules) * 100}%` }}
              aria-valuenow={completed}
              aria-valuemin={0}
              aria-valuemax={course.totalModules}
              role="progressbar"
            />
          </div>
        </div>

        <div className="flex gap-4 items-center mt-4 md:mt-0">
          <Link
            to={`/courses/${course.id}/modules`}
            className="bg-indigo-600 px-5 py-2 rounded-md text-center text-white hover:bg-indigo-700 transition"
            aria-label={`${isCompleted ? "Review" : "Continue"} modules for ${course.title}`}
          >
            {isCompleted ? "Review Modules" : "Continue"}
          </Link>

          {isCompleted && (
            <button
              className="bg-green-600 px-5 py-2 rounded-md text-white hover:bg-green-700 transition"
              onClick={() => alert("🎉 Certificate will be generated soon!")}
              aria-label={`Download certificate for ${course.title}`}
            >
              🎓 Request Certificate
            </button>
          )}
        </div>
      </div>
    );
  })}
</div>

  );
};

export default Dashboard;
